import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import ErrorMessage from "components/form/ErrorMessage";

export default function TextInputField({
  control,
  name,
  label,
  gridProps,
  require,
  question,
  questionIdx,
  answerId,
  disabled,
  ...props
}) {
  return (
    <Grid item xs={12} {...gridProps} className="!mb-4">
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#00B74F",
          mb: 0.5,
        }}
      >
        Câu {questionIdx + 1}:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#25282B",
          mb: 3,
          wordWrap: "break-word",
        }}
      >
        {question.title}
      </Typography>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              ref={field.ref}
              label={question?.children[0]?.title}
              value={
                (field.value || [])[0]?.text ||
                question?.children[0]?.answerText
              }
              onChange={(event) => {
                field.onChange([{ answerId, text: event.target.value }]);
              }}
              error={error?.message}
              helperText={<ErrorMessage message={error?.message} />}
              fullWidth
              disabled={disabled}
              InputLabelProps={{
                shrink: true,
                sx: {
                  fontWeight: 600,
                  color: "#52575C",
                },
              }}
              size="small"
              FormHelperTextProps={{ variant: "standard" }}
              sx={{
                "& .MuiInputBase-root.Mui-disabled": {
                  color: "#000000de", // màu chữ
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000de", // màu chữ
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: "#000000de", // màu label khi disabled
                },
              }}
              {...props}
            />
          );
        }}
      />
      <div
        className="pt-2"
        dangerouslySetInnerHTML={{ __html: question?.description }}
      />
    </Grid>
  );
}
